import { useState, useContext } from 'react';
import { Dropdown, Menu, Space } from 'antd';
import { DeleteOutlined, EditOutlined, EllipsisOutlined, ContainerOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import EditableTitle from './EditableTitle';
import useHttp from '../../hooks/useHttp';
import { API_URL } from '../../services/api';
import ChatContext from '../../store/ChatContext';
import { message as antMessage } from 'antd';
import './Sidebar.css';

const ChatEntry = ({ item, collapsed, onDeleteChat, onArchiveChat, activeKey, onCollapse }) => {
  const [chatTitle, setChatTitle] = useState(item.chatTitle);
  const [isEditing, setIsEditing] = useState(false);
  const history = useHistory();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const chatCtx = useContext(ChatContext);

  const {putRequest} = useHttp();

  const handleTitleChange = (newTitle) => {
    if(newTitle.length > 150){
      antMessage.error('Chat title cannot be more than 150 characters');
      return;
    }
    if (newTitle.trim() || newTitle.length > 0) {
      setChatTitle(newTitle);
      putRequest({
        url: API_URL + '/app/ap1/agent/chat/rename?chatIdentifier=' + item.chatIdentifier,
        data: {
          chatTitle: newTitle
        },
        onResponse: (response) => {
            chatCtx.onChatRefresh();
        },
        onError: (error) => {
          console.log(error);
        }, showLoader: false
      });
    }else{
        antMessage.error('Please enter a chat title');
    }
    
  };
  

  const handleMenuClick = (e) => {
    e.stopPropagation();
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const handleChatClick = () => {
    if(item.chatIdentifier){
      chatCtx.setConnectionId(item.chatIdentifier);
      chatCtx.setAgentId(item.agentId);
      history.replace(`/chat/${item.chatIdentifier}`);
    }
    onCollapse(true);
  };
  return (
    <Menu.Item
      key={'/chat/' + item.chatIdentifier}
      onClick={handleChatClick}
      className={`sidebar-menu-item ${activeKey === '/chat/' + item.chatIdentifier ? '!bg-blue-200' : ''}`}
    >
      {!collapsed && (
        <div className='flex items-center justify-between gap-2 align-center'>
          <div className="flex-grow overflow-hidden">
            <EditableTitle 
              chatIdentifier={item.chatIdentifier}
              initialTitle={chatTitle || 'New Chat'} 
              onTitleChange={handleTitleChange}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
            />
          </div>
          <div>
          <Dropdown
           overlayClassName="custom-dropdown-menu"
           open={dropdownOpen}
           onOpenChange={setDropdownOpen}
            menu={{ 
              items: [
                {
                  key: '1',
                  label: (
                    <a 
                      className="flex items-center" 
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsEditing(true);
                        closeDropdown(); 
                      }}
                    >
                      <EditOutlined className="w-3 h-3 mr-2" />
                      <span>Rename</span>
                    </a>
                  ),
                },
                { 
                  key: '2',
                  label: (
                    <a className="flex items-center" onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onArchiveChat(item.chatIdentifier);
                    }}>
                      <ContainerOutlined className="w-3 h-3 mr-2" />
                      <span>Archive</span>
                    </a>
                  ),
                },
                {
                  key: '3',
                  label: (
                    <a className="flex items-center" onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onDeleteChat(item.chatIdentifier);
                    }}>
                      <DeleteOutlined className="w-3 h-3 mr-2" />
                      <span>Delete</span>
                    </a>
                  ),
                },
              ]
            }}
            trigger={['click']}
          >
            <a onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleMenuClick(e);
            }}>
              <Space>
                <EllipsisOutlined  />
              </Space>
            </a>
          </Dropdown>
          </div>
        </div>
      )}
    </Menu.Item>
  );
};

export default ChatEntry;